export const PHPLINK = "https://ganotras.in/server/api/";
export const TESTKEY = 'rzp_test_RDOGxEyKdskgkl';
export const LIVEKEY = 'rzp_live_RuxdGlyqHcM46x';
//export const PHPLINK = "http://localhost/mytech/server/api/";